import React from 'react'
import { Clock } from 'lucide-react'
import Reveal from '../components/Reveal'

const HOURS = [
  { day: 'Mon — Fri', time: '08:00 — 18:00' },
  { day: 'Saturday',  time: '08:00 — 17:00' },
  { day: 'Sunday',    time: '09:00 — 15:00' },
]

export default function OfficeHours() {
  return (
    <Reveal variant="fade-up" threshold={0.2} className="cp-hours">
      <div className="cp-hours__inner">
        <div className="cp-hours__label">
          <Clock size={13} strokeWidth={1.5} style={{ display: 'block', marginBottom: 6 }} />
          Office Hours
        </div>
        <div className="cp-hours__items">
          {HOURS.map(({ day, time }) => (
            <div key={day} className="cp-hours__item">
              <span className="cp-hours__day">{day}</span>
              <span className="cp-hours__time">{time}</span>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  )
}
